import React from 'react';
import { motion } from 'framer-motion';
const terraceNightAsset = { url: "/assets/terrace-night.jpg" };

export function TransitionImage() {
  return (
    <section className="bg-[#FDFCF8] py-8 lg:py-16 overflow-hidden">
      <div className="max-w-screen-2xl mx-auto px-0 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="relative group md:rounded-[28px] overflow-hidden shadow-2xl shadow-black/10"
        >
          <motion.div
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="aspect-[16/9] md:aspect-[16/8] w-full"
          >
            <img
              src={terraceNightAsset.url}
              alt="Walnut Farm Terrace at Night"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            {/* Subtle dark gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-40" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
